import { FormSpy, useForm } from 'react-final-form';
import { useSelector } from 'react-redux';

import styles from './DecisionFieldMark.module.scss';
import {
  getUserRoleIsProsecutorOrSuperProsecutor,
  getUserRoleIsSupervisor,
} from '../../../AuthPackage/MainModule/selectors/authSelectors';
import { IKnmForm } from '../../../KnmPackage/MainModule/interfaces/IKnmForm';
import { REQUIRED_ERROR } from '../../../CorePackage/MainModule/constants/validationErrors';
import { decisionFieldsMarkedAsRequired } from './decisionFieldsMarkedAsRequired';
import { getDecisionDataAgreementOnApproval, getDecisionStatusHintFields } from '../selectors/decisionSelectors';

interface IErknmFieldMarkProps {
  fieldName?: string;
  sectionName?: string;
}

const idRegex = /\[\d+]/gi;

export const DecisionFieldMark = ({ fieldName, sectionName }: IErknmFieldMarkProps) => {
  const form = useForm();
  const isSupervisor = useSelector(getUserRoleIsSupervisor);
  const isProsecutorOrSuperProsecutor = useSelector(getUserRoleIsProsecutorOrSuperProsecutor);
  const isAgreementOnApproval = useSelector(getDecisionDataAgreementOnApproval);
  const statusHintFields = useSelector(getDecisionStatusHintFields);

  const fieldNameTemplate = fieldName?.replaceAll(idRegex, '[{id}]');

  return (
    <FormSpy subscription={{ values: true, errors: true, touched: true }}>
      {() => {
        const isShowRequiredMark =
          (isSupervisor ||
            (isProsecutorOrSuperProsecutor &&
              (isAgreementOnApproval || (fieldNameTemplate || '').indexOf('agreements[{id}].terminate') > -1))) &&
          !!fieldNameTemplate &&
          decisionFieldsMarkedAsRequired.includes(fieldNameTemplate);

        const isShowRedMark = isShowRequiredMark;
        const isShowYellowMark = statusHintFields?.some(
          // обработчик для случаев с field array
          el => {
            return (
              el.field === fieldNameTemplate ||
              (fieldNameTemplate !== fieldName && (el.field || '').replaceAll(idRegex, '[{id}]') === fieldNameTemplate)
            );
          },
        );

        const field = form.getFieldState(fieldName as keyof IKnmForm);
        const isError = typeof field?.error === 'string';
        const isEmpty = !field?.value || (Array.isArray(field?.value) && !field?.value.length);

        if (
          fieldName &&
          isShowRedMark &&
          isError &&
          !sectionName &&
          (isEmpty || fieldName === 'approved' || field?.error === REQUIRED_ERROR)
        ) {
          return <span className={styles.RedMark}> *</span>;
        }

        if (fieldName && isShowYellowMark && isEmpty) {
          return <span className={styles.YellowMark}> *</span>;
        }

        if (sectionName && isShowYellowMark) {
          return <span className={styles.YellowMark}> *</span>;
        }

        return null;
      }}
    </FormSpy>
  );
};
